import { gettext } from '@eventbrite/i18n';
import type { TimeSlotProps } from '@eventbrite/timed-entry';

export enum DateFormatType {
    short = 'short',
    long = 'long',
}

export const TAB_HEADERS: Array<string> = [
    gettext('Morning').toString(),
    gettext('Afternoon').toString(),
    gettext('Night').toString(),
];

export const SESSION_SIZE = 32;

export type DayPart = {
    Morning: TimeSlotProps[];
    Afternoon: TimeSlotProps[];
    Night: TimeSlotProps[];
};

export const longDateFormat: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
};

export type MonthAndYear = {
    month: number;
    year: number;
};

export type SessionsByDurationAndTimeOfDay = Record<
    string,
    Record<keyof DayPart, ExtendedTimeSlotProps[]>
>;

export interface ExtendedTimeSlotProps extends TimeSlotProps {
    endDatetime: string;
}
